import React, { Component } from 'react';
import api, { API_ENDPOINTS } from '../../api/Api';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {reactLocalStorage} from 'reactjs-localstorage';
import { isLogin, logout } from '../../utils';
import { Link } from 'react-router-dom';

import AccountMenu from './AccountMenu';

class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            old_password:'',
            new_password:'',
            confirm_new_password:'',
            serviceCheck:false,
        }   
    }


    async ChangePassword(){

        const { old_password, new_password, confirm_new_password}  = this.state ;

        if (old_password.length < 6 || new_password.length < 6 || confirm_new_password.length < 6) {
            NotificationManager.error('Password minimum 6 characters required');
        }else if(new_password!=confirm_new_password){
            NotificationManager.error('Passwords not matched');
        }else{

          const params = new URLSearchParams();
          params.append('token', localStorage.getItem('natureway_token'));
          params.append('old_password', old_password);
          params.append('new_password', new_password);
            try {
                const response = await api.post(API_ENDPOINTS.legacy.changePassword, params);
                let resVal=response.data;
                if(resVal.status=='success'){
                    NotificationManager.success(resVal.message);
                    this.setState({old_password:'', new_password:'', confirm_new_password:''});
                    logout();
                    setTimeout(()=>{
                        this.props.history.push('/');
                    },2000);
                }else{
                    NotificationManager.error(resVal.message);
                }
            } catch (error) {
                console.error(error);
            }

        }
    }


    storeState(elementName,event) {
        if(elementName=='mobile_number'){
            this.setState({mobile_number:event.target.value});
        }else if(elementName=='password'){
                this.setState({password:event.target.value});
        }
    }

    render() {
        const { old_password, new_password, confirm_new_password }  = this.state ;
        return (
            <div className="ps-account-page ps-change-password-page">
                <div className="ps-categogy ps-categogy--separate">
                    <div className="container whiteContainer">
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <AccountMenu/>
                            </div>
                            <div className="col-12 col-md-9">
                                <ul className="ps-breadcrumb">
                                    <li className="ps-breadcrumb__item"><Link to="/">Account Settings</Link></li>
                                    <li className="ps-breadcrumb__item active" aria-current="page">Change Password</li>
                                </ul>

                                <div className="ps-change-password__hero">
                                    <div className="ps-change-password__heroContent">
                                        <span className="ps-change-password__eyebrow">Security</span>
                                        <h1>Keep your account safe with a stronger password</h1>
                                        <p>Update your password anytime to protect your account and keep your Natureway profile secure.</p>
                                    </div>
                                    <div className="ps-change-password__heroBadge">
                                        <i className="icon-lock"></i>
                                        <span>Protected access</span>
                                    </div>
                                </div>

                                <form className="accountBox ps-form--review ps-change-password__card">
                                    <div className="ps-change-password__sectionTitle">Update password</div>

                                    <div className="form-row">
                                        <div className="ps-form__group col-md-8 col-lg-6">
                                            <label className="ps-form__label">Old Password*</label>
                                            <input type="password" className="form-control ps-form__input" name="old_password" value={old_password} onChange={(event)=>this.setState({'old_password':event.target.value})}/>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="ps-form__group col-md-8 col-lg-6">
                                            <label className="ps-form__label">New Password*</label>
                                            <input type="password" className="form-control ps-form__input" name="new_password" value={new_password} onChange={(event)=>this.setState({'new_password':event.target.value})}/>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="ps-form__group col-md-8 col-lg-6">
                                            <label className="ps-form__label">Confirm New Password*</label>
                                            <input type="password" className="form-control ps-form__input" name="confirm_new_password" value={confirm_new_password} onChange={(event)=>this.setState({'confirm_new_password':event.target.value})}/>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="ps-form__group col-md-8 col-lg-6 ps-change-password__actions">
                                            <button type="button" className="ps-btn ps-btn--sm ps-btn--warning" onClick={()=>this.ChangePassword()}>Save changes</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default ChangePassword;
